export default __webpack_public_path__ + "67adbce1c4caa9f20fb16f763b8dbabd.png";